import { defineComponent as _defineComponent } from 'vue'
import { categories, MergedCategory, Video, VideoCategory, videos } from '@sh/components/Layout/TutorialDropdown';
import CategoriesCard from '@sh/components/Layout/TutorialDropdown/CategoriesCard.ts.vue';
import VideoCard from '@sh/components/Layout/TutorialDropdown/VideoCard.ts.vue';
import VideoModal from '@sh/components/Utils/ContentPreview/VideoModal.vue';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import { computed, getCurrentInstance, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TutorialDropdown.ts',
  setup(__props) {

const instance = getCurrentInstance();
const selectedCategory = ref<VideoCategory | null>(null);
const searchValue = ref('');
const selectedVideo = ref<Video | undefined>(undefined);
const isOpen = ref(false);

function getMergedCategoriesWithVideos(): MergedCategory[] {
  const videosByCategory = new Map<VideoCategory, Video[]>();

  videos.forEach((video) => {
    if (!videosByCategory.has(video.category)) videosByCategory.set(video.category, []);
    videosByCategory.get(video.category)?.push(video);
  });

  return categories
    .map((category) => ({
      ...category,
      videos: videosByCategory.get(category.category) || [],
    }))
    .filter((category) => category.videos.length > 0);
}

const categorizedVideos = ref(getMergedCategoriesWithVideos());

const filteredVideosBySearchAndCategory = computed(() => {
  if (searchValue.value) {
    return videos.filter((video) => video.title.toLowerCase().includes(searchValue.value.trim().toLowerCase()));
  }
  if (selectedCategory.value) {
    return videos.filter((video) => video.category === selectedCategory.value);
  }
  return videos;
});

function onSearch(searchText: string) {
  searchValue.value = searchText;
  selectedCategory.value = null;
}

function onCategorySelect(category: MergedCategory | null) {
  selectedCategory.value = category?.category || null;
  searchValue.value = '';
}

function handleVideoSelect(video: Video) {
  selectedVideo.value = video;
  isOpen.value = true;
}

function onHidePopover() {
  searchValue.value = '';
}

function onShowPopover() {
  const { path } = instance?.proxy.$route || {};
  if (!path) return;

  const matchedCategory = categories.find((category) =>
    category.routes.some((routePattern) => path.includes(routePattern))
  );

  selectedCategory.value =
    matchedCategory && videos.some((video) => video.category === matchedCategory.category)
      ? matchedCategory.category
      : null;
}

return { __sfc: true,instance, selectedCategory, searchValue, selectedVideo, isOpen, getMergedCategoriesWithVideos, categorizedVideos, filteredVideosBySearchAndCategory, onSearch, onCategorySelect, handleVideoSelect, onHidePopover, onShowPopover, videos, CategoriesCard, VideoCard, VideoModal, OptimizerIconV2 }
}

})